import { useTranslation } from 'react-i18next';

import FamilyStatus from './HaushaltElements/FamilyStatus.tsx';
import Pkw from './HaushaltElements/Pkw.tsx';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard';

type HaushaltProps = {
    antragsteller: 1 | 2;
};

const Haushalt: React.FC<HaushaltProps> = ({ antragsteller }) => {
    const { t } = useTranslation();

    return (
        <FormCard title={t('LIVING_SITUATION_DATA.HAUSHALT.TITLE')}>
            <Pkw antragsteller={antragsteller} />
            <FamilyStatus antragsteller={antragsteller} />
        </FormCard>
    );
};

export default Haushalt;
